<template>
  <span id="network-alert" v-if="showAlert || audioOnly">{{ networkMessage }}</span>
</template>

<script>
import { mapState } from 'vuex';
import DetectSpeed from '@/utils/detectSpeed';
import { isBrowserSupportsNetworkInfo } from '@/utils/common';
import logger from '@/modules/Logger';

export default {
  data() {
    return {
      showAlert: false
    };
  },
  mounted() {
    try {
      if (isBrowserSupportsNetworkInfo()) {
        navigator.connection.addEventListener('change', () => {
          this.getDownloadSpeed();
        });
        this.getDownloadSpeed();
      } else {
        setInterval(this.getDownloadSpeed, 60000);
      }
    } catch (error) {
      logger.error('Error encountered after mounting network component ' + error, {
        operation: 'utils:internet',
        event_type: 8,
        lesson_id: this.lessonId
      });
    }
  },
  computed: {
    ...mapState(['lessonId']),
    ...mapState('videoRtc', ['audioOnly']),

    networkMessage() {
      return this.audioOnly ? this.$t('networkAudioOnlyAlert') : this.$t('networkAlert');
    }
  },
  methods: {
    async displaySpeed() {
      this.$refs['speed'].innerHTML = parseInt(await DetectSpeed.generateSpeedData()) / 1000 + ' Mbps';
    },
    async getDownloadSpeed() {
      try {
        let speed = parseInt(await DetectSpeed.getSpeed());
        this.showAlert = window.navigator.onLine && (speed < 2000);
        DetectSpeed.sendInternetLog(speed);
      } catch (error) {
        logger.error('Error encountered on getDownloadSpeed ' + error, { 
          operation: 'utils:internet',
          event_type: 9,
          lesson_id: this.lessonId
         });
      }
    }
  }
};
</script>

<style scoped src="@/assets/css/pc/network.css"></style>
<style scoped src="@/assets/css/sp/network.css"></style>
